import {getCurrentScriptUrlContext} from '../../utils/getCurrentScriptUrlContext';
import type {ServiceEnvironment} from '../../utils/getTargetEnvironment';
import {
  getDevboxUrl,
  getTargetEnvironment,
  getTunnelUrl,
} from '../../utils/getTargetEnvironment';
import {isDevEnvironment} from '../../utils/isDevEnvironment';
import type {AuthenticatedUserFragmentData} from '../../data-layer-client/queries/authenticatedUserFragment';

export type AuthenticationState =
  | {status: 'unauthenticated'; userSessionExpired: boolean}
  | {
      status: 'user_authenticated';
      expires: Date;
      user: AuthenticatedUserFragmentData | null;
    }
  | {
      status: 'account_session_authenticated';
      expires: Date;
      userSessionExpired: boolean;
    }
  | {
      status: 'error';
      error: Error;
    };

export type AuthenticationStatus = AuthenticationState['status'];

export const authOriginsByEnvironment: Record<ServiceEnvironment, string> = {
  prod: 'https://connect.stripe.com',
  preprod: 'https://preprod-connect.stripe.com',
  qa: 'https://qa-connect.stripe.com',
  tunnel: getTunnelUrl('manage'),
  devbox: getDevboxUrl('manage'),
};

const currentEnvironment = () =>
  getCurrentScriptUrlContext().serviceEnvironment;

export function getTargetOriginForAuthContext(
  targetEnvironment: ServiceEnvironment = currentEnvironment(),
  environmentOverride: string | undefined = process.env.SERVICE_ENVIRONMENT,
  isDevelopmentBuild: boolean = isDevEnvironment,
) {
  return authOriginsByEnvironment[
    getTargetEnvironment(
      targetEnvironment,
      environmentOverride,
      isDevelopmentBuild,
    )
  ];
}

export function isAllowedAuthOrigin(origin: string) {
  const expectedOrigin = getTargetOriginForAuthContext();
  return expectedOrigin === origin;
}

export type AuthenticationKeyType =
  | 'account_session'
  | 'stripe_user'
  | 'external_account';

export type KeyAndType = {
  key: string;
  type: AuthenticationKeyType;
};
